var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhotoPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "180px",
    height: "180px",
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    fill: "#4A4A4A",
    cx: 90,
    cy: 90,
    r: 90
  }), /*#__PURE__*/React.createElement("g", {
    id: "Photo-Icon",
    transform: "translate(50.000000, 58.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow",
    opacity: 0.25,
    transform: "translate(0.000000, 15.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9997,0.0001 L19.9997,8.0001 L-0.0003,8.0001 L-0.0003,64.0001 L79.9997,64.0001 L79.9997,8.0001 L60.0007,8.0001 L50.0007,0.0001 L29.9997,0.0001 Z M3.9997,12.0001 L19.9997,12.0001 L21.4027,12.0001 L22.4987,11.1231 L31.4037,4.0001 L48.5967,4.0001 L57.5007,11.1231 L58.5967,12.0001 L60.0007,12.0001 L75.9997,12.0001 L75.9997,60.0001 L3.9997,60.0001 L3.9997,12.0001 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,48.5 C32.556,48.5 26.5,42.444 26.5,35 C26.5,27.556 32.556,21.5 40,21.5 C47.444,21.5 53.5,27.556 53.5,35 C53.5,42.444 47.444,48.5 40,48.5 M40,17.5 C30.335,17.5 22.5,25.335 22.5,35 C22.5,44.665 30.335,52.5 40,52.5 C49.665,52.5 57.5,44.665 57.5,35 C57.5,25.335 49.665,17.5 40,17.5",
    id: "Fill-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9997,0.0001 L19.9997,8.0001 L-0.0003,8.0001 L-0.0003,64.0001 L79.9997,64.0001 L79.9997,8.0001 L60.0007,8.0001 L50.0007,0.0001 L29.9997,0.0001 Z M3.9997,12.0001 L19.9997,12.0001 L21.4027,12.0001 L22.4987,11.1231 L31.4037,4.0001 L48.5967,4.0001 L57.5007,11.1231 L58.5967,12.0001 L60.0007,12.0001 L75.9997,12.0001 L75.9997,60.0001 L3.9997,60.0001 L3.9997,12.0001 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,48.5 C32.556,48.5 26.5,42.444 26.5,35 C26.5,27.556 32.556,21.5 40,21.5 C47.444,21.5 53.5,27.556 53.5,35 C53.5,42.444 47.444,48.5 40,48.5 M40,17.5 C30.335,17.5 22.5,25.335 22.5,35 C22.5,44.665 30.335,52.5 40,52.5 C49.665,52.5 57.5,44.665 57.5,35 C57.5,25.335 49.665,17.5 40,17.5",
    id: "Fill-2"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoPlaceholder);
export default __webpack_public_path__ + "static/media/photo_placeholder.ec72f3ed4aa384c624b86ae2d4dd09d5.svg";
export { ForwardRef as ReactComponent };